import { render, staticRenderFns } from "./GeofencesStatistics.vue?vue&type=template&id=37041f46"
import script from "./GeofencesStatistics.vue?vue&type=script&lang=js"
export * from "./GeofencesStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports